import { store } from '../store/store';
import { clearState } from '../reducers/cbcAuthorizationSlice';
import Bugsnag from '@bugsnag/expo';
import { Platform, Linking, AppState } from 'react-native';
import { navigate, goBack, getCurrentRoute } from '../hooks/navigationService';
import { QuickAuth } from './useQuickAuth';

let linkingSubscription = null;
export const focusHelper = async () => {
  const state = store.getState();
  const currentRoute = getCurrentRoute();

  if (Platform.OS !== 'web' && currentRoute !== 'login') {

  }
  // linkingSubscription = Linking.addEventListener('url', handleDeepLink);
  // const initialURL = await Linking.getInitialURL();
  // if (Platform.OS !== 'web' && currentRoute !== 'login') {
  //
  //   if (initialURL) {
  //     console.log('App opened from deep link:', initialURL);
  //     handleDeepLink({ url: initialURL });
  //   } else {
  //     const appState = AppState.currentState;
  //     if (appState === 'active') {
  //       Bugsnag.notify('User put app back in focus');
  //       store.dispatch(clearState());
  //       navigate('loadScreen', { goBack });
  //     }
  //   }
  // }
};


const handleDeepLink = (event) => {
  const { url } = event;
  console.log('Received deep link:', url);
  // Handle deep link here
  // For example, you can navigate to a specific screen based on the deep link data
  // navigate('deepLinkScreen', { deepLinkData: url });

  // Remove the event listener after handling the deep link
  if (linkingSubscription) {
    linkingSubscription.remove();
    linkingSubscription = null;
  }
};